"use client";

import { useCallback } from "react";

export default function BackToTop() {
    const scrollToTop = useCallback(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    return (
        <div className="fixed bottom-4 right-4 md:bottom-8 md:right-8">
            <button
                onClick={scrollToTop}
                className="w-10 h-10 md:w-12 md:h-12 bg-black hover:bg-transparent text-white rounded-full flex items-center justify-center shadow-lg transition-colors touch-manipulation"
                aria-label="Back to top"
            >
                <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 10l7-7m0 0l7 7m-7-7v18"
                    />
                </svg>
            </button>
        </div>
    );
}
